import { CardsCreate } from "@/components/Cards/Create"
import { CardsList } from "@/components/Cards/List"
import { CardsView } from "@/components/Cards/View"
import { memo } from "react"
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom"

const PayoutsPageComponent = () => {
  const { path } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route path={path} exact>
          <CardsList key="payouts-page" />
        </Route>
        <Route path={`${path}/create`}>
          <CardsCreate />
        </Route>
        <Route path={`${path}/:id`}>
          <CardsView />
        </Route>
        <Redirect to={path} />
      </Switch>
    </>
  )
}

export const PayoutsPage = memo(PayoutsPageComponent)
